import React from 'react';
import ReactImageFallback from 'react-image-fallback';
import Loader from 'angieslist-app-platform/lib/browser/Loader';
import { get } from 'lodash';
import moment from 'moment';
import ReactTruncate from 'react-truncate';
import { Showcase } from '../../common/profileService';

type Props = {
  showcase: Showcase,
  isMobile: boolean,
  isLoading: boolean,
};

const SlimShowcaseIndexCard = ({
  showcase,
  isMobile,
  isLoading,
}: Props) => {
  const fallbackImage = (
    <div className="slim-showcase-index-card-image" />
  );
  return (
    <Loader
      loading={isLoading}
      element={
        <div className="text-center" style={{ marginTop: '1em' }}>
          <i className="icon icon-load icon-spin icon-3x text-primary" />
        </div>}
    >
      <div className="slim-showcase-index-card">
        <If condition={!isMobile}>
          <div id={`showcase-index-card-image-${showcase.showcaseId}`}>
            <div className="image-wrapper">
              <ReactImageFallback
                src={get(showcase, 'displayMedia.url')}
                alt={showcase.caption}
                fallbackImage={fallbackImage}
                className="slim-showcase-index-card-image"
              />
            </div>
          </div>
        </If>
        <div id={`showcase-index-card-title-${showcase.showcaseId}`} className="slim-showcase-index-card-title">
          <div>
            <ReactTruncate lines={2}>{showcase.title}</ReactTruncate>
          </div>
          <div>
            <Choose>
              <When condition={showcase.showcaseStatus === 'Published'}>
                <div className="slim-showcase-index-card-info">
                  {showcase.mediaCount === 1 ? `${showcase.mediaCount} Photo` : `${showcase.mediaCount} Photos`}
                  <br />
                  {showcase.year}
                </div>
              </When>
              <Otherwise>
                <div className="slim-showcase-index-card-info">
                  {`Last saved ${moment(showcase.lastEdited).format('M/D/YYYY')}`}
                </div>
              </Otherwise>
            </Choose>
          </div>
        </div>
      </div>
    </Loader>
  );
};

export default SlimShowcaseIndexCard;



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/SlimShowcaseIndexCard.js